import { AfterContentChecked, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { ApplicationType } from './components/form-sections/form-intro/form-intro.component';
import { QueryFormType } from './components/form-sections/form-navigation/form-navigation.component';
import { AnalyticsEventObject, initAnalyticsObject } from './models/analytics-event.model';
import { FormSectionsStateModel } from './models/form-sections-state-default';
import { CallLogout, CallValidateSession, SendAnalyticsEvent, ToggleMenuOpen } from './onboarding.actions';
import { OnboardingGlobalStateModel } from './onboarding.state';


interface StoreModel {
  onbGlobalState: OnboardingGlobalStateModel;
  onbFormSectionsState: FormSectionsStateModel;
}

declare var adobeDataLayer;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit, AfterContentChecked {
  QueryFormType = QueryFormType; // exposing enum
  public title = 'Investec Onboarding';
  public menuOpen = false;
  public IE: boolean;
  public formStart = false;
  public formType = null;
  public phoneNumbers = { main: null, mobile: null };
  public screenChanged = 0;
  public timeout = 1800; // seconds
  public isLoggedIn = false;
  public TIMEOUT_MORTGAGES = 480; // 8 minutes
  private currentSection = '';

  constructor(private store: Store, private cdref: ChangeDetectorRef) {}

  ngOnInit(): void {
    let firstLoad = true;

    this.store.subscribe((res: StoreModel) => {
      this.menuOpen = res.onbGlobalState.menuOpen;
      this.isLoggedIn = res.onbGlobalState.isLoggedIn && res.onbGlobalState.isElevated;
      if (typeof res.onbFormSectionsState !== 'undefined') {
        if (res.onbFormSectionsState.formType !== null) {
          this.formType = res.onbFormSectionsState.formType.toLocaleUpperCase();
          if (this.formType === QueryFormType.UKMORTGAGE) {
            this.timeout = this.TIMEOUT_MORTGAGES; // 9 minutes
          }
          if (
            res.onbFormSectionsState.activeChildSectionName !== null &&
            this.currentSection !== res.onbFormSectionsState.activeChildSectionName
          ) {
            this.screenChanged++;
          }
        }
        this.formStart = res.onbFormSectionsState.formStart;
        if (firstLoad && typeof window['adobeDataLayer'] !== 'undefined') {
          firstLoad = false;
          const e = JSON.stringify(initAnalyticsObject);
          this.store.dispatch(new SendAnalyticsEvent(JSON.parse(e)));
        }
      }
    });
    this.IE = navigator.userAgent.indexOf('MSIE ') > -1 || navigator.userAgent.indexOf('Trident/') > -1;
  }

  ngAfterContentChecked(): void {
    this.cdref.detectChanges();
  }

  /**
   * Indicates if login capability is enabled.
   * Currently only works for Mortgages
   */
  hasLoginCapability(): boolean {
    // login is currently only enabled for Mortgages
    return this.formType === QueryFormType.UKMORTGAGE;
  }

  /**
   * Indicates whether to show telephone numbers in the header
   */
  showPhoneNumbers(): boolean {
    // don't show phone numbers on Mortgage
    return this.formType !== QueryFormType.UKMORTGAGE;
  }

  handleMenuClick(): void {
    this.store.dispatch(new ToggleMenuOpen());
  }

  sessionEnding(): void {
    const state = this.store.selectSnapshot((res: StoreModel) => res.onbFormSectionsState);
    const data: AnalyticsEventObject = {
      event: 'load',
      action: 'timed out',
      page: {
        form: {
          name: state.formType,
          applicationType:
            state.applicationType === ApplicationType.SOLE
              ? 'Individual'
              : state.applicationType === ApplicationType.JOINT
              ? 'Joint'
              : 'Company',
          section: state.activeSectionName === null ? null : state.activeSectionName.toLocaleLowerCase(),
          pagination: '',
          stepName: state.activeChildSectionName === null ? null : state.activeChildSectionName.toLocaleLowerCase(),
          leadID: state.referenceNumber,
        },
      },
    };
    this.store.dispatch(new SendAnalyticsEvent(data));
  }

  extendSession(): void {
    if (this.hasLoginCapability() && this.isLoggedIn) {
      this.store.dispatch(new CallValidateSession());
    }
  }

  logout(): void {
    this.store.dispatch(new CallLogout());
  }
}
